<template>
  <div v-if="appointment" class="desk-frame">
    <!-- desktop header -->
    <div class="head_row_calander bg--white flex no_mobile">
      <a class="head-link-blue head-link-back flex" @click="goBackRoute">
        <img src="/assets/img/svg/arrow_r.svg" />
        חזרה ליומן של {{ doctor.heb_name }}
      </a>
      <div class="flex">
        <a
          v-show="!appointmentPassed"
          class="head-link-blue flex"
          href="javascript:void(0);"
          @click.prevent="cancelPop"
        >
          <img src="/assets/img/svg/trash.svg" /> ביטול תור
        </a>
        <router-link
          class="head-link-blue flex"
          :to="'/app-edit/' + $route.params.id"
        >
          <img src="/assets/img/svg/ic-pen-blue.svg" />עריכה
        </router-link>
      </div>
    </div>
    <menu-desktop class="no_mobile" />
    <!-- mobile header -->
    <section
      class="mobile_add_new_head bg--white center flex flex--content--center relative"
    >
      <div class="title tx--black">פרטי תור</div>
      <a
        class="m_bt_head head_go_back flex m-flex--center"
        href="javascript:void(0);"
        @click.prevent="goBackRoute"
      >
        <ArrowBackSvg />
      </a>
      <router-link
        :to="'/app-edit/' + $route.params.id"
        class="m_bt_head head_save"
      >
        עריכה
      </router-link>
    </section>
    <section class="aprove_sur_page desk-flex desk-flex--top">
      <!-- side info -->
      <AppSideInfo :appointment="appointment" />

      <div class="app_info_main desk-is--fit">
        <AppActionTiles
          :appointment="appointment"
          :appointment-id="$route.params.id"
          :doctor-summary="doctor_summary"
        />

        <!-- documents info -->
        <AppDocuments
          :documents="documents"
          :isMobile="isMobile"
          @removeFile="removeFile"
        />

        <!-- main info -->
        <div class="inner_group" style="padding-bottom: 6px;">
          <div v-show="appointment.notes" class="add_new_row flex">
            <div class="add_new_row_col1 w-100">
              <h3 class="aprove_sur_title tx--blue ft--400 ">הערות תצוגה</h3>
            </div>
            <div class="add_new_row_col2 w-100 tx--right over--hide">
              {{ appointment.notes }}
            </div>
          </div>
          <div v-show="appointment.insurance_note" class="add_new_row flex">
            <div class="add_new_row_col1 w-100">
              <h3 class="aprove_sur_title tx--blue ft--400 ">הערות כלליות</h3>
            </div>
            <div class="add_new_row_col2 w-100 tx--right over--hide">
              {{ appointment.insurance_note }}
            </div>
          </div>

          <!-- approval status -->
          <div class="add_new_row flex desk-flex approval-checkbox-mobile">
            <div class="add_new_row_col1 w-100">
              <h3 class="aprove_sur_title tx--blue ft--400 ">
                סטטוס אישור הגעה
              </h3>
            </div>
            <!-- Approved approval checkbox -->
            <div v-if="!appointmentPassed" class="flex approval-container">
              <div class="form_check form_check-black">
                <label>
                  <input type="checkbox" v-model="isApprovalStatus" />
                  אישר/ה הגעה
                  <span class="checkmark"></span>
                </label>
              </div>
              <!-- Update approval-status button -->
              <div>
                <a
                  @click="sendApproveArrival"
                  href="javascript:void(0);"
                  class="flex flex--content--center status-btn"
                >
                  שמירה
                </a>
                <span v-show="isSuccess" class="status-btn-notice">
                  נשמר בהצלחה!
                </span>
              </div>
            </div>
            <div v-else class="flex row-margin-bottom">
              <span
                v-show="isApprovalStatus"
                class="ok-green"
                style="margin-left: 5px;"
              ></span>
              <span
                v-show="!isApprovalStatus"
                class="ic-error"
                style="margin-left: 5px;"
              ></span>
              {{ isApprovalStatus ? "" : "לא" }} אישר/ה הגעה
            </div>
          </div>
          <!-- end approval status -->

          <!-- arrival status  -->
          <div
            v-if="appointmentPassed"
            class="add_new_row flex desk-flex approval-checkbox-mobile"
          >
            <div class="add_new_row_col1 w-100">
              <h3 class="aprove_sur_title tx--blue ft--400 ">
                דיווח הגעה לתור
              </h3>
              <span style="font-size: 18px;">*יש לבחור את אחד השדות</span>
            </div>
            <div class="flex approval-container">
              <!-- Approved arrival checkbox -->
              <div class="flex desk-flex approval-checkbox-mobile">
                <div class="form_check form_radio desk-no-marge">
                  <label class="form_check_tx">
                    הגיע/ה
                    <input
                      type="radio"
                      :value="true"
                      v-model="isArrivalStatus"/>
                    <span class="checkmark"></span
                  ></label>
                </div>
                <div class="form_check form_radio desk-no-marge">
                  <label class="form_check_tx">
                    לא הגיע/ה
                    <input
                      type="radio"
                      :value="false"
                      v-model="isArrivalStatus"/>
                    <span class="checkmark"></span
                  ></label>
                </div>
              </div>
              <!-- Update Arrival-status button -->
              <div>
                <a
                  @click="sendArrivalStatus"
                  href="javascript:void(0);"
                  class="flex flex--content--center status-btn"
                >
                  שמירה
                </a>
                <span v-show="isSuccess" class="status-btn-notice">
                  נשמר בהצלחה!
                </span>
              </div>
            </div>
          </div>
          <!-- end arrival status -->

          <!-- mobile buttons -->
          <div
            class="add_new_row desk-hide"
            v-if="!appointmentPassed"
            style="border:none"
          >
            <a
              class="flex flex--content--center app-summery-btn"
              href="javascript:void(0)"
              v-if="!appointmentPassed"
              @click.prevent="cancelPop"
            >
              <TrashSvg /> ביטול תור
            </a>
          </div>
        </div>
        <!-- end mobile buttons -->
      </div>
    </section>
  </div>
</template>

<script>
import ArrowBackSvg from "../../../assets/img/svg/arrow_back.svg";
import TrashSvg from "../../../assets/img/svg/trash.svg";
import CancelPop from "../../Popups/CancelApp";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import Error from "@/components/Popups/Error";
import AppActionTiles from "./AppActionTiles.vue";
import AppSideInfo from "./AppSideInfo.vue";
import AppDocuments from "./AppDocuments.vue";
import { getHash } from "../../../utilities/hash.js";
import { mapGetters } from "vuex";

export default {
  name: "AppInfo",
  data() {
    return {
      appointment: null,
      doctor: null,
      documents: [],
      isAppSummery: false,
      doctor_summary: null,
      isApprovalStatus: null,
      isArrivalStatus: "default",
      isMobile: false,
      isSuccess: false
    };
  },
  async created() {
    this.isMobile = window.innerWidth < 1200;
  },
  async beforeMount() {
    this.getAppointmentInfo();
    // Listen if added documents & get appointment info
    this.$root.$on("getAppointmentInfo", () => {
      if (this.$route.name != "app-info") return;
      this.getAppointmentInfo();
    });
  },
  watch: {
    "$route.params.id"() {
      this.getAppointmentInfo();
    }
  },
  methods: {
    async getAppointmentInfo() {
      const res = await this.$API.getAppointmentInfo(this.$route.params.id);
      this.appointment = res.message.appointment;
      this.doctor = res.message.doctor;
      this.documents = res.message.documents;
      const summery = res.message.doctor_summary;
      if (summery) this.doctor_summary = summery.replace("\\", "");

      // issue in backend dev approval status return as arrival_status
      this.isApprovalStatus =
        this.appointment.arrival_status &&
        this.appointment.arrival_status.includes("approved");
      // issue in backend dev arrival status return as status
      if (this.appointment.status == "arrived") {
        this.isArrivalStatus = true;
      } else if (this.appointment.status == "no_show") {
        this.isArrivalStatus = false;
      }
    },
    cancelPop() {
      this.$modal.show(
        CancelPop,
        {
          appointment_id: this.$route.params.id,
          appDate: this.appointment.start_datetime.substring(0, 10)
        },
        {
          clickToClose: true
        }
      );
    },
    goBackRoute() {
      const isMobile = window.innerWidth < 1200;
      if (isMobile) {
        this.$router.go(-1);
        return;
      }
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || !Object.keys(hashData).length) {
        return this.$router.push("/dashboard");
      }
      const hash = getHash({});
      this.$router.push(`/dashboard/#${hash}`);
    },
    async sendApproveArrival() {
      try {
        this.onApprovalStatus();
        await this.$API.approveArrival(this.appointment);
        this.isSuccess = true;
        setTimeout(() => {
          this.isSuccess = false;
        }, 2500);
      } catch (er) {
        this.isApprovalStatus = false;
        this.$modal.show(Error);
      }
    },
    async sendArrivalStatus() {
      if (this.isArrivalStatus == "default") return;
      try {
        await this.$API.statusArrival(
          this.$route.params.id,
          this.isArrivalStatus
        );
        this.isSuccess = true;
        setTimeout(() => {
          this.isSuccess = false;
        }, 2500);
      } catch (error) {
        this.$modal.show(Error);
      }
    },
    onApprovalStatus() {
      // issue in backend dev approval status return as arrival_status
      if (!this.isApprovalStatus) {
        this.appointment.arrival_status = "tentative";
        return;
      }
      switch (this.appointment.arrival_status) {
        case "approved":
          this.appointment.arrival_status = "approved";
          break;
        case "approved-doc":
          this.appointment.arrival_status = "approved-doc";
          break;
        case "tentative":
        default:
          this.appointment.arrival_status = "approved-doc";
          break;
      }
    },
    removeFile(index) {
      const file = this.documents[index];
      this.$API.uploadFile(
        this.appointment.id,
        "cancel",
        file.id,
        file.name,
        [],
        false,
        file.type
      );
      this.documents.splice(index, 1);
    }
  },
  computed: {
    ...mapGetters(["showCellosignPage"]),
    appointmentPassed() {
      if (this.appointment) {
        let today = this.$moment();
        let appoitment_time = this.$moment(
          new Date(this.appointment.start_datetime)
        );
        if (today.isAfter(appoitment_time)) {
          return true;
        }
      }
      return false;
    }
  },
  components: {
    ArrowBackSvg,
    TrashSvg,
    MenuDesktop,
    AppActionTiles,
    AppSideInfo,
    AppDocuments
  }
};
</script>
<style scoped>
.app-summery-btn {
  border: 1px solid #324997;
  border-radius: 5px;
  padding: 10px 0;
  margin-top: 10px;
  gap: 5px;
}

.status-btn {
  min-width: 100px;
  font-size: 22px;
  font-weight: 600;
  height: 35px;
  background-color: #324997;
  color: white;
  border-radius: 5px;
}

.status-btn:hover {
  background-color: #2a2e80;
}

.status-btn-notice {
  font-size: 18px;
  color: green;
  margin-right: 7px;
  position: absolute;
}

.grey-bottom {
  padding-bottom: 23px;
  border-bottom: 1px solid;
  border-bottom-color: #efefea;
}

.reset-margin {
  margin-bottom: 0 !important;
}

/* Desktop only */
@media screen and (min-width: 1200px) {
  .approval-container {
    gap: 16px;
  }
}

/* Mobile only */
@media screen and (max-width: 1199px) {
  .status-btn {
    border: 1px solid #324997;
    border-radius: 5px;
    background-color: inherit;
    color: #324997;
    height: 30px;
    width: 64px;
    font-size: 19px;
  }

  .status-btn:hover {
    background-color: inherit;
  }

  .approval-container {
    width: 100%;
    margin-bottom: 10px;
  }

  .approval-checkbox-mobile .form_radio {
    margin-top: 5px;
    margin-bottom: 10px;
  }

  .grey-bottom {
    border-bottom: none !important;
  }

  .app_info_delite {
    border-top: 0;
  }

  .row-margin-bottom {
    margin-bottom: 10px;
  }
}

.n-email {
  font-size: 20px;
}
</style>
